import React from "react";
import { Dropdown } from "antd";
import classNames from "classnames";

const AntDDropdown = ({
  menu,
  trigger = ["hover"], // "click" | "hover"
  placement = "bottomLeft", // "bottomLeft" | "bottomRight" | "topLeft" | "topRight"
  disabled = false, // true | false
  menuClassName = "", // "sw-ant-dropdown"
  className = "", // "sw-ant-dropdown-trigger"
  onOpenChange,
  children,
}) => {
  return (
    <Dropdown
      menu={menu}
      trigger={trigger}
      placement={placement}
      disabled={disabled}
      onOpenChange={onOpenChange}
      classNames={{
        root: classNames("sw-ant-dropdown", menuClassName),
      }}
    >
      <span className={classNames("sw-ant-dropdown-trigger", className)}>
        {children}
      </span>
    </Dropdown>
  );
};

export default AntDDropdown;
